import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router";

import App from "./App.jsx";
import "./app.scss";
import "./utils/i18n.js";

Sentry.init({
	dsn: "https://d586b9256b5386f16c35c17f8820d39b@sentry2.sailingbyte.com/58",
	environment:
		import.meta.env.VITE_STAGE === "production" ? "production" : "test",
	integrations: [
		Sentry.reactRouterV7BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration(),
		Sentry.browserProfilingIntegration(),
	],
	tracesSampleRate: import.meta.env.VITE_STAGE === "production" ? 0.3 : 1.0,
	replaysSessionSampleRate:
		import.meta.env.VITE_STAGE === "production" ? 0.3 : 1.0,
	replaysOnErrorSampleRate: 1.0,
	tracePropagationTargets: [
		"localhost",
		/^https:\/\/apptest\.profitboard\.pl/,
		/^https:\/\/app\.profitboard\.pl/,
	],
	enabled:
		import.meta.env.PROD &&
		(import.meta.env.VITE_STAGE === "production" ||
			import.meta.env.VITE_STAGE === "test"),
	debug: import.meta.env.VITE_STAGE === "test",
});

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
